import {Component, EventEmitter, Input, Output, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {AdminService} from '../../../../../../services/admin.service';
import {ReviewSuggestionListsService} from '../../../services/review-suggestion-lists.service';
import {SuggestionListsService} from '../../../services/suggestion-lists.service';
import {ActivatedRoute, Router} from '@angular/router';
import { SuggestionListUserOption } from '../suggestion-list-user-option.model';
import {Subscription} from 'rxjs/Subscription';
import {HttpStatus} from '../view-suggestion-list.constants';
import {HttpResponse} from '@angular/common/http';

const EMPTY_RESPONSE = '';
const FIRST_DIVISION_INDEX = 0;
const LAST_DIVISION_OFFSET = 1;
const TASK_SUCCESS = 'Request was successfully sent!';
const TASK_ERROR = 'Error sending a request to create tasks in PlanFix for the Heads of the selected Divisions.';
const EXPIRED_ROUTE = 'ex-suggestion-expired';
const NOTIFICATIONS_ROUTE = '/ex-notifications';
const MY_SUGGESTIONS_ROUTE = '/dashboard/my-suggestion-lists/my-lists';
const NOTIFY_ID_PARAMETER = 'notifyId';
const HTTP_CONFLICT = 409;
const HTTP_SERVER_ERROR = 500;
const ASSIGNMENT_UNRESOLVED = 'SUGGESTION_ASSIGNMENT_PENDING';

interface TaskContainer {
  id: string;
  name?: string;
  headId?: string;
}

@Component({
  selector: 'app-implementation-members',
  templateUrl: './implementation-members.component.html',
  styleUrls: ['./implementation-members.component.css']
})
export class ImplementationMembersComponent implements OnInit, OnChanges, OnDestroy {
  @Output() assignmentStateChanged = new EventEmitter<void>();
  private taskRequest: Subscription;
  private divisionsRequest: Subscription;

  @Input() users: SuggestionListUserOption[] = [];
  @Input() error: boolean;
  @Input() towpath;
  @Input() iniciatorListId;
  isLoaded = false;
  errorMsg = false;
  allDivision: any[] = [];
  countOfDays = 2;
  selectedDivisions: any[] = [];
  toSend;
  responseMsg = '';
  showSuccessMsg = false;
  showErrorMsg = false;
  diableToPlanfixBtn = false;
  initiator;
  deputyPlanfixTasksGroups: any[] = [];
  nobodyPlanfixTasksGroups: any[] = [];
  notifyID:string;
  flag = false;

  constructor(private adminService: AdminService,
              private route: ActivatedRoute,
              private router: Router,
              public suggestionListsService: SuggestionListsService,
              public reviewSuggestionListsService: ReviewSuggestionListsService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes || changes['users'] || changes['iniciatorListId']) {
      this.syncUserSelection();
    }
  }

  ngOnInit() {
    this.syncUserSelection();
    this.notifyID = this.route.snapshot.params[NOTIFY_ID_PARAMETER];
    this.responseMsg = EMPTY_RESPONSE;
    this.showSuccessMsg = false;
    this.showErrorMsg = false;
    this.diableToPlanfixBtn = false;

    this.suggestionListsService.firstDisableService = false;

    this.deputyPlanfixTasksGroups = [];
    this.nobodyPlanfixTasksGroups = [];
    this.suggestionListsService.setDeputyPlanfixTasksGroups(this.deputyPlanfixTasksGroups);
    this.suggestionListsService.setNobodyPlanfixTasksGroups(this.nobodyPlanfixTasksGroups);

    this.isLoaded = false;
    this.loadDivisions();
  }

  private loadDivisions(): void {
    this.divisionsRequest = this.adminService.getAllGroupsHeadPlanfix(this.reviewSuggestionListsService.getOpenedSLID()).subscribe(
      (res: HttpResponse<TaskContainer[]>) => {
        this.completeDivisions(res.status === HttpStatus.OK ? res.body || [] : []);
      },
      () => this.showDivisionError()
    );
  }

  private completeDivisions(divisions: TaskContainer[]): void {
    this.allDivision = divisions.map(division => ({
      division: division, taskDesc: EMPTY_RESPONSE, isChecked: false, placeHolder: EMPTY_RESPONSE
    }));
    this.isLoaded = true;
  }

  private showDivisionError(): void {
    this.errorMsg = true;
    this.isLoaded = true;
  }

  isDivisionSelected(division) {
    return this.selectedDivisions.includes(division);
  }

  fieldsChangeDivision(values: any, division) {
    if (values.currentTarget.checked) {
      // CHECK
      division.isChecked = true;
      // Placeholder
      if (division.taskDesc.trim().length < 1) {
        division.placeHolder = 'Add task description...';
      }
      // Add division to selected list
      if (!this.isDivisionSelected(division)) {
        this.selectedDivisions.push(division);
      }

    } else {
      // UNCHECK
      division.isChecked = false;

      if (division.taskDesc.trim().length < 1) {
        division.placeHolder = '';
      }

      // Remove division from selected list
      if (this.isDivisionSelected(division)) {
        const index = this.selectedDivisions.indexOf(division);
        this.selectedDivisions.splice(index, 1);
      }

    }

    this.responseMsg = '';
    this.showSuccessMsg = false;
    this.showErrorMsg = false;

  }

  changeTextArea(division) {
    if (division.taskDesc.trim().length > 0) {
      if (!division.isChecked) {
        division.isChecked = true;

        // Add division to selected list
        if (!this.isDivisionSelected(division)) {
          this.selectedDivisions.push(division);
        }
      }
    } else {
      if (division.isChecked) {
        division.isChecked = false;

        // Remove division from selected list
        if (this.isDivisionSelected(division)) {
          const index = this.selectedDivisions.indexOf(division);
          this.selectedDivisions.splice(index, 1);
        }

      }
      // Clear placeholder
      division.placeHolder = '';
    }

    this.responseMsg = '';
    this.showSuccessMsg = false;
    this.showErrorMsg = false;

  }

  makeFieldsDisabled() {
    // Is disabled by default
    let dis = false;
    if (this.selectedDivisions.length > 0) {
      this.selectedDivisions.forEach(sd => {
        if (sd.taskDesc.trim().length < 1) {
          dis = true;
        }
      });
    } else {
      // Make disabled
      dis = true;
    }
    return dis;
  }

  setInitiator(userId: string): void {
    if (this.getAvailableUsers().some(user => user.id === userId)) {
      this.initiator = userId;
    }
  }

  private syncUserSelection(): void {
    const availableUsers = this.getAvailableUsers();
    this.flag = availableUsers.some(user => user.id === this.iniciatorListId);

    if (!availableUsers.length) {
      this.initiator = null;
      return;
    }

    const currentSelectionExists = availableUsers.some(user => user.id === this.initiator);
    if (!currentSelectionExists) {
      this.initiator = this.defaultUserId(availableUsers);
    }
  }

  private defaultUserId(users: SuggestionListUserOption[]): string {
    if (this.error && this.towpath && users.some(user => user.id === this.towpath.id)) {
      return this.towpath.id;
    }
    return users[FIRST_DIVISION_INDEX].id;
  }

  private getAvailableUsers(): SuggestionListUserOption[] {
    return Array.isArray(this.users)
      ? this.users.filter(user => !!user && !!user.id)
      : [];
  }

  markNotify(itemId) {
    const sendingParams = {
      id: itemId,
      notificationCategory: "SUGGESTION"
    };
    this.adminService.notifyIsView(sendingParams).subscribe(
      (response: any) => { },
      () => {
      }
    );
  }

  createPlanfixTasks() {
    if (this.diableToPlanfixBtn) { return; }
    const divisionIndex = this.error ? FIRST_DIVISION_INDEX : this.selectedDivisions.length - LAST_DIVISION_OFFSET;
    const taskDivision = this.selectedDivisions[divisionIndex];
    this.responseMsg = EMPTY_RESPONSE;
    this.showSuccessMsg = false;
    this.showErrorMsg = false;
    this.diableToPlanfixBtn = true;
    this.toSend = {
      slId: this.reviewSuggestionListsService.getOpenedSLID(),
      taskDeadline: this.countOfDays,
      userId: this.initiator,
      groupId: taskDivision.division.id,
      taskDescription: taskDivision.taskDesc
    };
    this.taskRequest = this.suggestionListsService.sendToPlanfix(this.toSend).subscribe(
      (response: {status: number}) => this.handleTaskResponse(response.status),
      error => this.assignmentFailed(error)
    );
  }

  ngOnDestroy(): void {
    if (this.taskRequest) {
      this.taskRequest.unsubscribe();
    }
    if (this.divisionsRequest) {
      this.divisionsRequest.unsubscribe();
    }
  }

  private handleTaskResponse(status: number): void {
    if ([HttpStatus.OK, HttpStatus.CREATED, HttpStatus.NO_CONTENT].indexOf(status) < FIRST_DIVISION_INDEX) {
      this.showTaskError();
      return;
    }
    this.responseMsg = TASK_SUCCESS;
    this.showSuccessMsg = true;
    this.showErrorMsg = false;
    this.diableToPlanfixBtn = false;
    this.suggestionListsService.firstDisableService = true;
    this.suggestionListsService.showSuccessMsgForReviewList = true;
    this.navigateAfterAssignment();
  }

  private navigateAfterAssignment(): void {
    if (this.router.url.includes(EXPIRED_ROUTE)) {
      this.markNotify(this.notifyID);
      this.router.navigate([NOTIFICATIONS_ROUTE]);
      return;
    }
    this.router.navigate([MY_SUGGESTIONS_ROUTE]);
  }

  private showTaskError(): void {
    this.responseMsg = TASK_ERROR;
    this.showSuccessMsg = false;
    this.showErrorMsg = true;
    this.diableToPlanfixBtn = false;
  }

  private assignmentFailed(error: {status: number}): void {
    this.showTaskError();
    if (error.status === HTTP_CONFLICT || error.status === FIRST_DIVISION_INDEX || error.status >= HTTP_SERVER_ERROR) {
      this.diableToPlanfixBtn = true;
      this.responseMsg = ASSIGNMENT_UNRESOLVED;
      this.assignmentStateChanged.emit();
    }
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/suggestion-lists/components/view-suggestion-list/implementation-members/implementation-members.component.ts